// Waive a missing scorecard (D7, CR-023): a reason of 3–2000 characters, recorded with the actor and time. A waiver is
// evidence of why the card is absent, never a score: his rule "Do not finalize with missing scorecards." keeps the
// outcome gate shut, so the dialog says so.
import { useState } from "react";
import { Button, Dialog, DIALOG_LABELS, SCORECARD_STATUS, SLIDE_LABELS, TextArea } from "@/mc";
import { scorecardWaive } from "@/api/tools";
import { errorText, useWrite } from "@/api/useTool";
import type { RoomPanelProps } from "@/views/b7/room/types";
import { DECIDE_RULES, reasonOk, ROOM_KEYS } from "./labels";

export function WaiveDialog({ view, onChanged, scorecardId }: RoomPanelProps & { scorecardId?: string | undefined }) {
  const write = useWrite(scorecardWaive, ROOM_KEYS);
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [refused, setRefused] = useState<string | null>(null);
  if (!scorecardId) return null;
  const ok = reasonOk(reason);
  const submit = async () => {
    if (!ok) return;
    setRefused(null);
    try {
      await write.mutateAsync({ requisition_id: view.requisition_id, scorecard_id: scorecardId, reason: reason.trim() });
      setOpen(false);
      setReason("");
      onChanged();
    } catch (e) {
      setRefused(errorText(e));
    }
  };
  return (
    <>
      <Button tone="ghost"  can={view.can.waive_scorecard !== false} onClick={() => setOpen(true)}>
        {SCORECARD_STATUS.waived}
      </Button>
      <Dialog
        title={SCORECARD_STATUS.waived}
        open={open}
        onClose={() => setOpen(false)}
        dismissLabel={DIALOG_LABELS.cancel}
        hint={DECIDE_RULES.missingScorecardKeepsOpen}
        refused={refused ? { reason: refused } : undefined}
        primary={{
          label: SCORECARD_STATUS.waived,
          onClick: () => void submit(),
          blocked: ok ? undefined : { reason: DECIDE_RULES.missingScorecardKeepsOpen },
          busy: write.isPending,
          hs: "room.waive.submit",
        }}
      >
        <TextArea label={SLIDE_LABELS.reason} required value={reason} onChange={(e) => setReason(e.target.value)} />
      </Dialog>
    </>
  );
}
